<template>
  <div>
    <div class="container page-body">
      <!-- <h2>Images List Pending</h2>
      <div v-for="image in imagesList('Pending')" :key="image.id">
        {{ image.breed }} {{ image.caption }}
      </div> -->

      <div class="general-panel">
        <div class="general-panel__header general-panel--green">
          <h5 class="general-panel__header-text">
            <i class="general-panel__header-icon fas fa-book-open"></i>
            Published: {{ numberImages }}
          </h5>
        </div>

        <ToggleControl
          toggle-id="list-desc"
          closed-text="About this list"
          open-text="- hide about -"
          toggle-class="general-panel__toggle-pane general-panel--green"
        >
          <template v-slot:default="slotProps">
            {{ slotProps.togglerText.display }}
          </template>
        </ToggleControl>

        <ToggleControl
          v-if="numberPublications > 0"
          toggle-id="pubs-list"
          closed-text="Publications Summary List..."
          open-text="- hide publications summary -"
          toggle-class="general-panel__toggle-pane general-panel--green"
        >
          <template v-slot:default="slotProps">
            {{ slotProps.togglerText.display }}
          </template>
        </ToggleControl>

        <div class="general-panel__content">
          <b-collapse id="list-desc">
            <div class="general-panel__row general-panel__row--standard-text">
              <p class="mb-0">Number of Images Published: {{ numberImages }}</p>
              <p>Number of Publications: {{ numberPublications }}</p>
              <p class="font-weight-bold mb-1">Published List Overview</p>
              <p>
                This list shows your images that have been published in a book
                or calendar and are available for purchase!
              </p>
              <p>
                The number in the green button above and in the header of this
                text block is how many images are in this list:
                <strong>{{ numberImages }}</strong>
              </p>
              <p>
                An image in this list at one point
                <span class="italic">was</span> in your
                <strong>Selected</strong> list; it no longer appears there.
              </p>
              <p>
                For each image listed here, you can see which publication(s)
                it's in. Each publication is listed with its title and link
                where its available for purchase.
              </p>
            </div>
          </b-collapse>

          <b-collapse id="pubs-list">
            <div class="general-panel__row general-panel__row--standard-text">
              <p class="font-weight-bold mb-1">
                Your Published {{ imagesAppearPhrase }} In:
              </p>

              <ul class="image-card__list image-card__list--pub-summary-panel">
                <li v-for="pub in publications" :key="pub.creTime">
                  <a class="image-card__link" :href="pub.url" target="_blank">{{
                    pub.title
                  }}</a>
                  {{ pub.platform }}
                </li>
              </ul>
            </div>
          </b-collapse>

          <div
            v-if="numberImages > 0"
            class="general-panel__row general-panel__row--3col"
          >
            <div>
              <!-- need div since css grid defined on this element ... per <transitiion-group> in ImagesListPending component -->
              <CardImage
                v-for="image in images"
                :key="image.id"
                :image="image"
                :type="type"
                :showHeader="showHeader"
                :showButtonPanel="showButtonPanel"
                :showProductsPanel="showProductsPanel"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleControl from '@/components/layout/ToggleControl';
import CardImage from '@/components/cards/CardImage';
import { mapGetters } from 'vuex';

function sortByCreateTime(dataArray, sortOrder) {
  // If sortOrder is NOT des, set it to empty str (which will be set to default value of 'asc' in following line).
  // With these two lines, we force sortOrder to be one of 'asc' or 'des' no matter what the function is called with.
  sortOrder = sortOrder !== 'des' ? '' : sortOrder;
  sortOrder = sortOrder || 'asc';

  const sortFunction =
    sortOrder === 'asc'
      ? (a, b) => a.creTime - b.creTime
      : (a, b) => b.creTime - a.creTime;
  dataArray.sort(sortFunction);
  return dataArray;
}

export default {
  name: 'ImagesListPublished',
  components: {
    ToggleControl,
    CardImage,
  },
  data: function () {
    return {
      componentKey: 1,
      type: 'published',
      showHeader: true,
      showButtonPanel: false,
      showProductsPanel: true,
      images: [],
    };
  },
  watch: {
    // If the number of images in this view, e.g. 'pending' images, changes (e.g. one gets put in the 'selected' bin),
    // re-render the view to reflect this.
    numberImages: function () {
      this.rerenderView();
    },
  },
  computed: {
    ...mapGetters('uploadTracker', ['imagesList']),

    numberImages: function () {
      return this.imagesList('Published').length;
    },

    publications: function () {
      var pubs = [];
      this.images.forEach((i) => {
        i.projects.forEach((p) => {
          pubs.push(p);
        });
      });
      return pubs;
    },
    numberPublications: function () {
      return this.publications.length;
    },

    imagesAppearPhrase: function () {
      return this.numberImages > 1 ? 'Images Appear' : 'Image Appears';
    },
  },
  methods: {
    rerenderView: function () {
      this.$parent.rerenderView();
    },
  },
  created: function () {
    var published = this.imagesList('Published');

    // If this route is current route, hitting browser refresh might have the two arrays NOT set yet
    if (published) {
      this.images = sortByCreateTime(published, 'des');
    }

    var imageNum = 1;
    this.images.forEach((image) => {
      image.imageNum = imageNum;
      imageNum++;
    });
  },
};
</script>

<style>
</style>